import { sidebarNavState } from 'state/sidebar-nav';

const NavigationService = {
    toggleMobileSidebar: () => {
        sidebarNavState.isOpen = !sidebarNavState.isOpen;
    },
};

export { NavigationService };
